import type { RouteEntries } from './route-utils';

import dashboardEntry from './dashboard';
import dashboardEditEntry from './dashboardEdit';
import schemasEntry from './schemas';
import dashboardTemplatesEntry from './dashboardTemplates';
import dashboardTemplatesEditEntry from './dashboardTemplatesEdit';
import deviceEntry from './device';
import sitesEntry from './sites';
import adminEntry from './admin';
import subscriptionEntry from './subscription';
import siteCreateEntry from './siteCreate';
import siteDashboardEditEntry from './siteDashboardEdit';
import resourceGroupEntry from './resourceGroup';
import siteEntry from './site';
import deviceRegisterEntry from './deviceRegister';
import devicesEntry from './devices';

export const routes: RouteEntries = [
  { path: '/dashboard', entry: dashboardEntry },
  { path: '/sites/dashboard/:id', entry: siteDashboardEditEntry },
  { path: '/dashboard/edit', entry: dashboardEditEntry },
  { path: '/sites', entry: sitesEntry },
  { path: '/site/create', entry: siteCreateEntry },
  { path: '/admin', entry: adminEntry },
  { path: '/admin/subscriptions/:subscriptionId', entry: subscriptionEntry },
  {
    path: '/admin/subscriptions/:subscriptionId/resourceGroups/:resourceGroupId',
    entry: resourceGroupEntry,
  },
  {
    path: '/admin/subscriptions/:subscriptionId/resourceGroups/:resourceGroupId/sites/:siteId',
    entry: siteEntry,
  },
  {
    path: '/admin/subscriptions/:subscriptionId/resourceGroups/:resourceGroupId/deviceRegisters/:deviceRegisterId',
    entry: deviceRegisterEntry,
  },
  { path: '/schemas', entry: schemasEntry },
  { path: '/dashboard-templates', entry: dashboardTemplatesEntry },
  { path: '/dashboard-templates/:id', entry: dashboardTemplatesEditEntry },
  { path: '/device/:id', entry: deviceEntry },
  { path: '/devices', entry: devicesEntry },
];
